<template>
	<div id="login" class="authenticate">
		<app-head title="Login" />

		<v-card elevation="0">
			<v-card-title>
				<div class="d-flex w-100">
					<h5 class="text-h5 mb-3 font-weight-bold">
						Log In
					</h5>
				</div>
			</v-card-title>
			<v-card-text>
				<v-form v-model="valid" @submit.prevent="form.post(route('login'))">
					<v-text-field
						v-model="form.email"
						:error="exists(form.errors.email)"
						:hide-details="!exists(form.errors.email)"
						:error-messages="form.errors.email"
						name="email"
						class="mb-4"
						label="Email Address"
						required
						outlined
						autofocus></v-text-field>
					<v-text-field
						v-model="form.password"
						:error="exists(form.errors.password)"
						:hide-details="!exists(form.errors.password)"
						:error-messages="form.errors.password"
						name="password"
						label="Password"
						type="password"
						class="mb-3"
						required
						outlined></v-text-field>
					<v-checkbox
						v-model="form.remember"
						label="Remember Me"
						class="mt-0 mb-6"
						hide-details></v-checkbox>
					<div class="d-flex align-center">
						<v-btn color="primary"
							elevation="0"
							large
							rounded
							type="submit"
							:loading="form.processing">
							Log In
						</v-btn>
						<div class="ml-5">
							<Link :href="route('password.request')" class="text--secondary">
								Forgot Password?
							</Link>
						</div>
					</div>
				</v-form>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
import Auth from '@/Layouts/Auth'
import AppHead from '@/Shared/AppHead'
import form from '@/Mixins/form'

export default {
	components: { AppHead },
	mixins: [form],
	layout: Auth,
	props: {
		//
	},
	data () {
		return {
			valid: false,
			form: this.$inertia.form({
				email: null,
				password: null,
				remember: true
			})
		}
	}
}
</script>
